export enum MapTypes {
  SET_MAP_CENTER = 'ui/map/SET_MAP_CENTER',
  SET_MAP_CENTER_AND_ZOOM = 'ui/map/SET_MAP_CENTER_AND_ZOOM',
  TOGGLE_CAR_MARKERS = 'ui/map/TOGGLE_CAR_MARKERS',
  TOGGLE_AREA_POLYGONS = 'ui/map/TOGGLE_AREA_POLYGONS',
  TOGGLE_PARKING_AREA_POLYGONS = 'ui/map/TOGGLE_PARKING_AREA_POLYGONS',
}
